import { useState } from 'react'
import { Tabs, Tag, Typography } from 'antd'
import { AimOutlined, DatabaseOutlined, ExperimentOutlined, FileSearchOutlined } from '@ant-design/icons'
import '../../../styles/aurora-page.css'
import '../../../styles/aurora-modal.css'
import RegexTab from './RegexTab'
import SqlExplainTab from './SqlExplainTab'
import LogAnalyzeTab from './LogAnalyzeTab'
import LocatorTab from './LocatorTab'

const { Title } = Typography

/** 日志与文本主页面：AI 增强的主战场，四个页签模块 */
export default function LogText() {
  const [activeKey, setActiveKey] = useState('regex')

  return (
    <div className="aurora-page aurora-page--fit">
      {/* ① 页头 */}
      <div className="page-header">
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <Title level={4} style={{ margin: 0, fontWeight: 600 }}>日志与文本</Title>
          <Tag color="warning" style={{ borderRadius: 999 }}>AI 结果可能存在幻觉，请务必本地验证后使用</Tag>
        </div>
      </div>

      {/* ② 主内容卡片：四页签内嵌（与「数据构造」「报文调试」页结构统一） */}
      <div className="content-card">
        <Tabs
          activeKey={activeKey}
          onChange={setActiveKey}
          tabBarStyle={{ paddingLeft: 22 }}
          items={[
            {
              key: 'regex',
              label: (
                <span><ExperimentOutlined /> 正则生成与解释</span>
              ),
              children: <RegexTab />,
            },
            {
              key: 'sql',
              label: (
                <span><DatabaseOutlined /> SQL 与 EXPLAIN 解读</span>
              ),
              children: <SqlExplainTab />,
            },
            {
              key: 'log',
              label: (
                <span><FileSearchOutlined /> 日志智能分析</span>
              ),
              children: <LogAnalyzeTab />,
            },
            {
              key: 'locator',
              label: (
                <span><AimOutlined /> 定位器生成器</span>
              ),
              children: <LocatorTab />,
            },
          ]}
        />
      </div>
    </div>
  )
}
